/**
 * A utility function to identify the lenderUser browser
 */

 export const isChromeBrowser = () => {
    const chromeRegex = new RegExp('chrome', 'i');
    return chromeRegex.test(navigator.userAgent);
};
